import PersonalInformationSection from './PersonalInformationSection';
import InformationSectionPart1 from './InformationSectionPart1';

const NewPolicyPage5 = () => {
  return (
    <>
      <PersonalInformationSection />
      <InformationSectionPart1 />
    </>
  );
};

export default NewPolicyPage5;
